<template>
  <div>
    <div id="header-container" class="pl-5">
      <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header" />
      <div class="pt-4 text-white">
        <h3 class="text-white">{{ $t("Transfer") }}</h3>
        <span class="fz-16 fw-400">{{
          $t("View your transfer report here")
          }}</span>
      </div>
    </div>

    <b-container fluid class="mt-0 pb-5">
      <b-row class="pt-3">
        <b-col cols="12">
          <div id="body-container">
            <b-row>
              <b-col cols="12" md="7" class="text-left">
                <h5 class="fz-22 fw-700">{{ $t("Transfer") }}</h5>
              </b-col>
              <b-col cols="12" md="5" class="text-right mb-3" v-if="!is_master">
                <button class="btn btn-primary" @click="addTransfer">
                  {{ $t("Transfer now") }}
                </button>
              </b-col>
            </b-row>
            <TransferHistory type="transfer"> </TransferHistory>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <LoaderComponent v-if="isLoading"></LoaderComponent>
  </div>
</template>
<script>
import LoaderComponent from "@/components/LoaderComponent";
import RecipientList from "@/components/RecipientList";
import TransferHistory from "@/components/TransferHistory";
import CreateAccount from "@/services/CreateAccount";
import Account from "@/services/Account";

export default {
  name: "transfer",
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
      isLoading: false,
      is_master: false,
      accountslist: "",
    };
  },
  components: {
    LoaderComponent,
    RecipientList,
    TransferHistory,
  },
  methods: {
    checkPayee(account) {
      let self = this;
      Account.listPayee().then((response) => {
        if (response.status == 200) {
          const data = response.data.data;

          data.forEach(function (item) {
            if (item.relationship_userNo == account) {
              self.is_master = true;
            }
          });
        }
      });
    },
    addTransfer() {
      this.$router.push({
        path: "/add-transfer",
      });
    },
    checkError(err) {
      try {
        this.isLoading = false;
        const response = err.response;
        if (response.status == 400) {
          console.log(response.data);
          if (typeof response.data.message === "string") {
            this.$notify({
              type: "warn",
              text: response.data.message,
            });
          } else {
            if (response.data.message["errorMsg"]) {
              this.$notify({
                type: "warn",
                text: response.data.message["errorMsg"],
              });
            } else {
              let ret = [];
              Object.keys(response.data.message).forEach((key) => {
                ret.push(response.data.message[key][0]);
              });

              this.$notify({
                type: "warn",
                html: ret.join("<br>"),
              });
            }
          }
        } else if (
          response.status == 401 &&
          response.data.name == "Unauthorized"
        ) {
          localStorage.removeItem("token");
          localStorage.removeItem("member");
          localStorage.removeItem("isFirstTime");
          this.$router.push({
            path: "/login",
          });
        } else {
          if (localStorage.getItem("token")) {
            var msg = response.data ? response.data.message : err.message;
            this.$notify({
              type: "warn",
              text: msg,
            });
          }
        }
      } catch (e) {
        console.log(err);
      }
    },
  },
  mounted() {
    let self = this;
    this.$nextTick(() => {
      CreateAccount.list().then((response) => {
        if (response.status == 200) {
          let account = response.data.data;
          this.accountslist = response.data.data[0].information.name;
          if (account) {
            let selected = "";
            account.forEach((element) => {
              if (element.status == 2) {
                selected = element.userNo;
              }
            });

            if (selected) {
              self.checkPayee(selected);
            }
          }
        }
      });
    });
  },
};
</script>
